var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.66406L11.5 3.66406M11.5 3.66406C11.5 5.04477 12.6193 6.16406 14 6.16406C15.3807 6.16406 16.5 5.04477 16.5 3.66406C16.5 2.28335 15.3807 1.16406 14 1.16406C12.6193 1.16406 11.5 2.28335 11.5 3.66406ZM6.5 10.3307L16.5 10.3307M6.5 10.3307C6.5 11.7114 5.38071 12.8307 4 12.8307C2.61929 12.8307 1.5 11.7114 1.5 10.3307C1.5 8.95002 2.61929 7.83073 4 7.83073C5.38071 7.83073 6.5 8.95002 6.5 10.3307Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetup);
export default __webpack_public_path__ + "static/media/setup.9117a19c50230c691f1bb550f2ad729f.svg";
export { ForwardRef as ReactComponent };